import React from "react";
import { Container, FlexWrapper, Text4, Text5, Text6 } from "../Common/index";
import {
  FooterButton,
  FooterLink,
  FooterLinkHeading,
  FooterMainContainer,
  FooterRowContainer,
  FooterSection,
  FooterSectionTwo,
  ImageLogo,
  MainWrapper,
  SocialMediaIcon,
  SocialMediaIconContainer,
  SpecialContainerDesktop,
  SpecialContainerMobile,
  SpecialSocialMediaContainer,
  StyleTextOne,
} from "./styles";
import LogoImage from "../../Assets/logooo.png";
import Twitter from "../../Assets/Twitter.svg";
import Facebook from "../../Assets/Facebook.svg";
import Linkedin from "../../Assets/Linkedin.svg";
const Footer = () => {
  return (
    <MainWrapper>
      <Container backgroundColor={"black"} width={"95%"} margin={"0px auto"}>
        <FooterMainContainer
          margin={"50px 0px 5px 0px"}
          wrap={"wrap"}
          justify={"center"}
          // align={"center"}
        >
          <SpecialContainerMobile>
            <FooterSection direction={"column"} width={"25%"} padding={'0px'} fixAlign={"flex-start"}>
              <ImageLogo src={LogoImage} />
              <Text5
                color={"white"}
                align={"left"}
                margin={"0px 0"}
                weight={900}
                fontFamily={"Inter"}
              >
                Hi I'm Escribelo
                <br /> your AI writer.
              </Text5>
            </FooterSection>
            <SocialMediaIconContainer width={"50%"} gap={"10px"}>
              <SocialMediaIcon src={Linkedin} />
              <SocialMediaIcon src={Facebook} />
              <SocialMediaIcon src={Twitter} />
            </SocialMediaIconContainer>
          </SpecialContainerMobile>
          <SpecialContainerDesktop direction={"column"} width={"25%"}>
            <ImageLogo src={LogoImage} />
            <Text5 color={"white"} align={"left"} margin={"0px 0"} weight={900}>
              Hi I'm Escribelo
              <br /> your AI writer.
            </Text5>
          </SpecialContainerDesktop>

          <FooterSection
            direction={"column"}
            width={"30%"}
            gap={"40px"}
            minWidth={"600px"}
          >
            <FooterRowContainer
              direction={"row"}
              width={"100%"}
              justify={"center"}
              wrap={"wrap"}
            >
              <FooterSectionTwo
                direction={"column"}
                width={"50%"}
                align={"flex-start"}
                justify={"flex-start"}
                minWidth={250}
              >
                <FooterLinkHeading>Product</FooterLinkHeading>
                <FooterLink>Partner Login</FooterLink>
                <FooterLink>Starter Features</FooterLink>
                <FooterLink>Pro Features</FooterLink>
                <FooterLink>Boss Mode Features</FooterLink>
                <FooterLink>25+ Languages Pricing</FooterLink>
              </FooterSectionTwo>

              <FooterSectionTwo
                direction={"column"}
                width={"50%"}
                minWidth={250}
              >
                <FooterLinkHeading >Content</FooterLinkHeading>
                <FooterLink>Reviews</FooterLink>
                <FooterLink>The Escribelo Blog</FooterLink>
                <FooterLink>Expert Videos</FooterLink>
              </FooterSectionTwo>
            </FooterRowContainer>

            <FooterRowContainer
              direction={"row"}
              width={"100%"}
              justify={"center"}
              wrap={"wrap"}
            >
              <FooterSectionTwo
                width={"50%"}
                direction={"column"}
                minWidth={250}
              >
                <FooterLinkHeading >Customer Support</FooterLinkHeading>
                <FooterLink>Live 101 Trainings</FooterLink>
                <FooterLink>Official Bootcamp</FooterLink>
                <FooterLink>FAQ & Help Center</FooterLink>
                <FooterLink>App Status </FooterLink>
                <FooterLink>hey@escribelo.ai</FooterLink>
              </FooterSectionTwo>
              <FooterSectionTwo
                direction={"column"}
                width={"50%"}
                minWidth={250}
              >
                <FooterLinkHeading >Company</FooterLinkHeading>

                <FooterLink color={"white"}>Affiliate Partners</FooterLink>
                <FooterLink color={"white"}>Jarvis Swag Store</FooterLink>
                <FooterLink color={"white"}>About The Team </FooterLink>
                <FooterLink color={"white"}>Brand Style Guide</FooterLink>
              </FooterSectionTwo>
            </FooterRowContainer>
          </FooterSection>

          <FooterSection direction={"column"} width={"25%"}>
            <FooterLinkHeading>Community</FooterLinkHeading>
            <StyleTextOne weight={800}>
              Join Our Facebook Group With Over 30,000 AI Copywriters
            </StyleTextOne>
            <FooterButton>
              <Text5> Go to facebook group</Text5>{" "}
            </FooterButton>
          </FooterSection>
        </FooterMainContainer>

        <FlexWrapper
          style={{ borderTop: "0.3px white solid", paddingTop: "30px" }}
          gap={"30px"}
        >
          <SpecialSocialMediaContainer>
            <SocialMediaIcon src={Linkedin} />
            <SocialMediaIcon src={Facebook} />
            <SocialMediaIcon src={Twitter} />
          </SpecialSocialMediaContainer>
          <Container width={"40%"} padding={'0px'}>
            <FooterRowContainer
              justify={"center"}
              width={"100%"}
              gap={30}
              wrap={"wrap"}
              align={"center"}
            >
              <Text6 color={"white"} >Privacy</Text6>
              <Text6 color={"white"}>terms</Text6>
              <Text6 color={"white"} weight={600}>@Escribelo.io</Text6>
            </FooterRowContainer>
          </Container>
        </FlexWrapper>
      </Container>
     </MainWrapper> 
  );
};

export default Footer;
